module.exports = __webpack_public_path__ + "static/case-western-reserve-university-f69526dffe965332c1aaaa65f22510bd.png";